import React from "react";
import { Link } from "react-router-dom";
import "./../../styles/home-sections/VideoSection.css";
import "./../../styles/NeonButton.css";

const VideoSection = () => {
  return (
    <div className="video-section section-container">
      <div className="video-container">
        <iframe
          src="https://www.youtube.com/embed/xnvjWz1F7dc"
          width="640"
          height="480"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="Video Chicas Rosas"
        ></iframe>
      </div>
      <div className="text-container">
        <h2 className="section-title">
          Llevamos desde 2016 preparando distintas ediciones del Camino
        </h2>
        <div className="section-text">
          <p>
            Los diferentes itinerarios del Camino han llevado caminando a las
            Chicas Rosas a través de paisajes que han recorrido toda la
            geografía de Galicia, confluyendo todos ellos en la Plaza del
            Obradoiro para presentarse ante el Apóstol Santiago en la Catedral.
          </p>
          <p>
            Se han iniciado caminos en Fisterra, Sarria, Valencia Do Miño,
            Ferrol, Ourense y desde san Vicente de la Barquera a Potes en el
            camino Lebaniego. Cada una de estas rutas ofrece un contexto único,
            lleno de belleza natural, historia y cultura, que enriquece la
            experiencia para todas las participantes.
          </p>
        </div>
        <Link to="/proxima-edicion-camino" className="neon-button button-left">
          Descubre la próxima edición
        </Link>
      </div>
    </div>
  );
};

export default VideoSection;
